import "./HomeStyles.css";
import React from 'react';

const Home = () => {
  return (
    <div className='home'>
      <div>
        <img src="/images/LOGOwithsubt.png"></img>
      </div>
      <div>
        <p>Neste portal, você tem acesso à vários Recursos Educacionais Digitais (RED), produzidos por parceiros do MEC. Possibilitando uma educação a qualquer lugar do mundo!</p>
      </div>
    </div>
  );
};

export default Home;